function Intro() {
  return (
    <div className="section-bgc intro" id="intro">
      <div
        className="intro-item intro-item-type-1"
        style={{ backgroundImage: "url('/assets/img/intro-img1.jpg')" }}
      >
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="intro-content" style={{ "--margin-left": "4rem" }}>
                <div className="section-heading shm-none">
                  <div className="section-subheading">Soluções sob medida para seu negócio</div>
                  <h1>Software de Gestão Desenvolvido para Sua Empresa</h1>
                  <p className="section-desc">
                    Desenvolvemos sistemas de gestão empresarial para diversos segmentos, 
                    com soluções personalizadas que resolvem os desafios específicos de cada cliente. 
                    Da concepção à entrega, transformamos necessidades reais em tecnologia eficiente.
                  </p>
                </div>
                <div className="btn-group intro-btns">
                  <a
                    href="#contact-form"
                    className="btn btn-border btn-with-icon btn-small ripple"
                  >
                    <span>Fale Conosco</span>
                    <svg className="btn-icon-right" viewBox="0 0 13 9" width="13" height="9">
                      <use xlinkHref="/assets/img/sprite.svg#arrow-right"></use>
                    </svg>
                  </a>
                  <a
                    href="#services"
                    className="btn btn-border btn-with-icon btn-small ripple"
                  >
                    <span>Nossos Serviços</span>
                    <svg className="btn-icon-right" viewBox="0 0 13 9" width="13" height="9">
                      <use xlinkHref="/assets/img/sprite.svg#arrow-right"></use>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Intro;
